export default __webpack_public_path__ + "static/balloons-898a24567681b5538e923f70f92ea348.jpg";